/* eslint-disable one-var */
(function () {
  'use strict';

  class CoachingCtrl {
    constructor($safetyService, $window, Authenticator, FeatureOuService, FeaturehubJsSdk, FeatureHubConfigKeys,
      $state, Keys, ServiceVfiltro, FactoryVfiltro, $translate, UrlService, ProntuarioLinkService) {
      this.window = $window;
      this.safetyService = $safetyService;
      this.translate = $translate;
      this.authenticator = Authenticator;
      this.user = {};
      this.featureOuService = FeatureOuService;
      this.featurehubJsSdk = FeaturehubJsSdk;
      this.featureHubConfigKeys = FeatureHubConfigKeys;
      this.state = $state;
      this.isFeatureFlagCoachingPageEnabled = this.featurehubJsSdk.isFeatureEnabled(this.featureHubConfigKeys.COACHING_PAGE);
      this.keys = Keys;
      this.serviceVfiltro = ServiceVfiltro;
      this.urlService = UrlService;
      this.prontuarioLinkService = ProntuarioLinkService;
      this.queryParams = this.urlService.parseQueryParams(this.window.location.search);
      this.authenticator.getUser()
        .then(user => {
          this.user = user;

          ServiceVfiltro.init(FactoryVfiltro.get([
            {
              key: this.keys.uo.name
            }
          ]))
          .then((filtro) => {
            this.filtro = filtro;
            this.initializePage(this.serviceVfiltro.getFiltroBackendNovo(this.filtro));
          });
        });
    }

    redirectToRankingMotoristas() {
      const url = this.state.href('root.rankingPontos', {
        vfiltro: `dateTime:mesAtual;uo:${this.user.uo.id}`,
        vtabela: 'currentPage:1;pageSize:150'
      });
      this.window.open(url, '_blank');
    }

    redirectToVehicleRegistration() {
      const url = this.state.href('root.veiculo', {
        vfiltro: `uo:${this.user.uo.id}`,
        vtabela: 'currentPage:1;pageSize:150'
      });
      this.window.open(url, '_blank');
    }

     formatDateWithTemplate(date) {
       let formatString = 'YYYY.MM.DD.hh.mm.ss.zz';
       const map = {
         YYYY: date.getFullYear(),
         MM: String(date.getMonth() + 1).padStart(2, '0'),
         DD: String(date.getDate()).padStart(2, '0'),
         hh: String(date.getHours()).padStart(2, '0'),
         mm: String(date.getMinutes()).padStart(2, '0'),
         ss: String(date.getSeconds()).padStart(2, '0')
       };
       formatString = formatString.replace(/YYYY|MM|DD|hh|mm|ss/g, (match) => map[match]);

       const tzOffset = date.getTimezoneOffset();
       const offsetSign = tzOffset > 0 ? '-' : '+';
       const offsetHours = String(Math.floor(Math.abs(tzOffset) / 60)).padStart(2, '0');
       const offsetMinutes = String(Math.abs(tzOffset) % 60).padStart(2, '0');
       formatString = formatString.replace('zz', `${offsetSign}${offsetHours}${offsetMinutes}`);
       return formatString;
     }

    redirectToProntuario(motoristaId) {
      const now = new Date();
      let startRange;
      let endRange;

      if (now.getDate() === 1) {
        startRange = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0);
        endRange = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59);
      } else {
        startRange = new Date(now.getFullYear(), now.getMonth(), 1, 0, 0, 0);
        endRange = new Date(now.getFullYear(), now.getMonth(), now.getDate() - 1, 23, 59, 59);
      }

      const dateTime = `${this.formatDateWithTemplate(startRange)},${this.formatDateWithTemplate(endRange)},personalizado`;
      const url = this.state.href('root.prontuarioV2', {
        vfiltro: `${this.keys.uo.name}:${this.user.uo.id};${this.keys.dateTime.name}:${dateTime};${this.keys.motorista.name}:${motoristaId}`
      });

      this.window.open(url, '_blank');
    }

    initializePage(filter) {
      this.safetyService.initialize()
      .then(() => this.loadPage(filter));
    }

    loadPage(filter) {
      const appName = 'safetyApp',
          componentPath = './CoachingPageRoute',
          componentId = 'safety-app-coaching',
          props = {
            user: this.user,
            filter: filter,
            hideTitle: this.hideTitle,
            onRedirectToRanking: this.redirectToRankingMotoristas.bind(this),
            onRedirectToProntuario: this.redirectToProntuario.bind(this),
            onRedirectToVehicleRegistration: this.redirectToVehicleRegistration.bind(this)
          };

      this.window.redirectToRankingMotoristas = this.redirectToRankingMotoristas.bind(this);
      this.window.redirectToProntuario = this.redirectToProntuario.bind(this);
      this.window.redirectToVehicleRegistration = this.redirectToVehicleRegistration.bind(this);

      if (this.isFeatureFlagCoachingPageEnabled) {
        this.safetyService.loadReactComponent(appName, componentPath, componentId, props);
      }
    }
  }
  CoachingCtrl.$inject = ['safetyService', '$window', 'Authenticator', 'FeatureOuService', 'FeaturehubJsSdk', 'FeatureHubConfigKeys', '$state', 'Keys', 'ServiceVfiltro', 'FactoryVfiltro', '$translate', 'UrlService'];
  angular.module('relatorios.coaching').controller('CoachingCtrl', CoachingCtrl);
}());
